// extracted by mini-css-extract-plugin
export default {"container":"AuthPage_container__ETBQG","logo":"AuthPage_logo__hziWM","footer":"AuthPage_footer__gk1P3"};